import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { TokensService } from './tokens.service';
import { Constants } from './constants-service';

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(private tokens: TokensService, private url: Constants) {}

  getAuthHeader(request) {
    const token = 'Bearer ' + this.tokens.getToken().access;
    const requestChange = request.clone({headers: request.headers.set('Authorization', token)});
    return requestChange;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.exception(request.url)) {
      const requestChange = this.getAuthHeader(request);
      return next.handle(requestChange).catch((error) => {
        if (error.status === 401) {
          console.log(error);
          return this.tokens.tokenRefresh().flatMap(() => {
            const requestChangeAuth = this.getAuthHeader(request);
            return next.handle(requestChangeAuth);
          });
        }
      });
    } else return next.handle(request);
  }

  exception(path) {
    return [
      '//' + this.url.setUrl() + ':' + this.url.PORT + '/api/login'
    ].some(item => item === path);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/interceptor.service.ts